import React, { useState } from 'react';

import {

  EditOutlined,

  DeleteOutlined,

  SupervisorAccountOutlined,

  ShieldOutlined,

  ManageAccountsOutlined,

} from '@mui/icons-material';

import ConfirmBar from '../../atoms/ConfirmBar/ConfirmBar';

import SupervisionModal from '../../molecules/Supervisionmodal/Supervisionmodal';

import ShareHierarchyModal from '../../molecules/ShareHierarchyModal/ShareHierarchyModal';

import AccessRightsModal from '../../molecules/AccessRightsModal/AccessRightsModal';

import SupervisorEditModal from '../../molecules/SupervisorEditModal/SupervisorEditModal';

import './UsersTable.css';
 
 
const UsersTable = ({

  usersList,

  allUsers = [],

  adminsList = [],

  isLoading,

  onEdit,

  onDelete,

  onToggleStatus,

  onSupervisionAdd,

  onSupervisionRemove,

  onShareHierarchy,

  onSaveRights,

  onRevokeRights,

  currentUser,

}) => {

  const [confirmAction, setConfirmAction]       = useState(null);

  const [supervisionAdmin, setSupervisionAdmin] = useState(null);

  const [shareAdmin, setShareAdmin]             = useState(null);

  const [accessRightsUser, setAccessRightsUser] = useState(null);

  const [supervisorEditUser, setSupervisorEditUser] = useState(null);

  const [togglingIds, setTogglingIds]           = useState(new Set());
 
  if (isLoading) return <div className="loading">Chargement...</div>;
 
  const handleDeleteClick = (user) => {

    setConfirmAction({

      type:      'delete',

      user,

      message:   'Supprimer',

      highlight: `${user.name} ${user.lastname}`,

    });

  };
 
  const handleStatusToggleClick = (user) => {

    setConfirmAction({

      type:      'status',

      user,

      message:   user.active ? 'Désactiver' : 'Activer',

      highlight: `${user.name} ${user.lastname}`,

    });

  };
 
  const handleConfirm = async () => {

    const { type, user } = confirmAction;
 
    if (type === 'delete') {

      await onDelete(user.id, user.username);  // ← passer username

      setConfirmAction(null);

      return;

    }
 
    if (type === 'status') {

      setTogglingIds((prev) => new Set(prev).add(user.id));

      try {

        await onToggleStatus?.(user.id, !user.active);

      } catch {

        // le toast d'erreur est déjà géré côté hook (useUsers)

      } finally {

        setTogglingIds((prev) => {

          const next = new Set(prev);

          next.delete(user.id);

          return next;

        });

      }

    }
 
    setConfirmAction(null);

  };
 
  const renderSupervisors = (user) => {

    const content = (() => {

      if (user.supervisors && user.supervisors.length > 0) {

        return (
<div className="supervisor-cell">

            {user.supervisors.map((supervisor, index) => (
<span key={supervisor.id} className="supervisor-name">

                {supervisor.name} {supervisor.lastname || supervisor.username}

                {index < user.supervisors.length - 1 && ', '}
</span>

            ))}
</div>

        );

      }

      if (user.supervisor_name) {

        return (
<div className="supervisor-cell">
<span className="supervisor-name">{user.supervisor_name}</span>
</div>

        );

      }

      return <span className="no-supervisor"> _________</span>;

    })();
 
    return (
<div className="supervisor-cell-wrapper">

        {content}
<button

          type="button"

          className="supervisor-edit-trigger"

          onClick={() => setSupervisorEditUser(user)}

          title="Modifier le(s) superviseur(s)"
>
<ManageAccountsOutlined />
</button>
</div>

    );

  };
 
  return (
<>
<div className="users-table-container">
<div className="users-table-scroll">
<table className="users-table">
<thead>
<tr>
<th>Utilisateur</th>
<th>Rôle</th>
<th>Superviseur(s)</th>
<th>Organisation</th>
<th>Statut</th>
<th>Actions</th>
</tr>
</thead>
<tbody>

              {usersList.length === 0 ? (
<tr>
<td colSpan="6" className="no-data">Aucun utilisateur trouvé</td>
</tr>

              ) : (

                usersList.map((user) => {

                  const isAdmin  = user.role === 'admin';

                  const toggling = togglingIds.has(user.id);

                  return (
<tr key={user.id}>
 
                      {/* ── Utilisateur ─────────────────────────────────── */}
<td>
<div className="user-cell">
<div className="user-avatar-wrapper">
<div className="user-avatar">

                              {user.name?.[0]?.toUpperCase()}

                              {user.lastname?.[0]?.toUpperCase()}
</div>
<span

                              className={`online-dot ${user.is_online ? 'online' : 'offline'}`}

                              title={user.is_online ? 'En ligne' : 'Hors ligne'}

                            />
</div>
<div className="user-info">
<div className="user-fullname-row">
<span className="user-fullname">

                                {user.name} {user.lastname}
</span>
</div>
<span className="user-email">{user.email}</span>
</div>
</div>
</td>
 
                      {/* ── Rôle ────────────────────────────────────────── */}
<td>
<span className={`role-badge ${user.role}`}>{user.role}</span>
</td>
 
                      {/* ── Superviseurs ─────────────────────────────────── */}
<td>{renderSupervisors(user)}</td>
 
                      {/* ── Organisation ─────────────────────────────────── */}
<td className="user-muted">{user.organization || '—'}</td>
 
                      {/* ── Statut ───────────────────────────────────────── */}
<td>
<button

                          type="button"

                          className={[

                            'user-status-toggle',

                            user.active ? 'user-status-toggle--on' : 'user-status-toggle--off',

                            toggling ? 'user-status-toggle--pending' : '',

                          ].filter(Boolean).join(' ')}

                          onClick={() => handleStatusToggleClick(user)}

                          disabled={toggling}

                          title={user.active ? 'Actif — cliquer pour désactiver' : 'Inactif — cliquer pour activer'}
>
<span className="user-status-toggle-track">
<span className="user-status-toggle-thumb">

                              {toggling && <span className="user-status-toggle-spinner" />}
</span>
</span>
<span className="user-status-toggle-label">

                            {user.active ? 'Actif' : 'Inactif'}
</span>
</button>
</td>
 
                      {/* ── Actions ─────────────────────────────────────── */}
<td>
<div className="actions">
 
                          <button

                            className="action-button access-rights"

                            onClick={() => setAccessRightsUser(user)}

                            title="Droits d'accès"
>
<ShieldOutlined />
</button>
 
                          <button

                            className={`action-button supervision${isAdmin ? '' : ' supervision--disabled'}`}

                            onClick={() => isAdmin && setSupervisionAdmin(user)}

                            title={isAdmin ? 'Modifier le(s) supervisé(s)' : undefined}
>
<SupervisorAccountOutlined />
</button>
 
                          <button

                            className="action-button edit"

                            onClick={() => onEdit(user)}

                            title="Modifier"
>
<EditOutlined />
</button>
 
                          <button

                            className="action-button delete"

                            onClick={() => handleDeleteClick(user)}

                            title="Supprimer"
>
<DeleteOutlined />
</button>
</div>
</td>
</tr>

                  );

                })

              )}
</tbody>
</table>
</div>
</div>
 
      {/* ── Modals ──────────────────────────────────────────────────────────── */}
 
      {confirmAction && (
<ConfirmBar

          message={confirmAction.message}

          highlight={confirmAction.highlight}

          onConfirm={handleConfirm}

          onCancel={() => setConfirmAction(null)}

        />

      )}
 
      {supervisionAdmin && (
<SupervisionModal

          admin={supervisionAdmin}

          allUsers={allUsers}

          onClose={() => setSupervisionAdmin(null)}

          onAdd={(targetAdminId) => onSupervisionAdd?.(supervisionAdmin.id, targetAdminId)}

          onRemove={(targetAdminId) => onSupervisionRemove?.(supervisionAdmin.id, targetAdminId)}

        />

      )}
 
      {shareAdmin && (
<ShareHierarchyModal

          sourceAdmin={shareAdmin}

          onClose={() => setShareAdmin(null)}

          onSubmit={async (sourceAdminId, data) => {

            await onShareHierarchy?.(sourceAdminId, data);

            setShareAdmin(null);

          }}

        />

      )}
 
      {accessRightsUser && (
<AccessRightsModal

          user={accessRightsUser}

          currentUser={currentUser}

          onClose={() => setAccessRightsUser(null)}

          onSave={onSaveRights}

          onRevoke={onRevokeRights}

        />

      )}
 
      {supervisorEditUser && (
<SupervisorEditModal

          user={supervisorEditUser}

          adminsList={adminsList}

          onAdd={onSupervisionAdd}

          onRemove={onSupervisionRemove}

          onClose={() => setSupervisorEditUser(null)}

        />

      )}
</>

  );

};
 
export default UsersTable;
 